import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createBlock(_component_el_select, {
    modelValue: _ctx.realValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.realValue = $event),
    ref: _ctx.selectRef,
    disabled: !_ctx.enabled,
    size: _ctx.size,
    loading: _ctx.loading,
    placeholder: _ctx.placeholder,
    "popper-class": _ctx.popperClass,
    "value-on-clear": _ctx.valueOnClear,
    clearable: _ctx.clearable,
    onBlur: _ctx.onBlur,
    "data-test": _ctx.dataTest,
    onChange: _ctx.onChangeValue,
    onClear: _ctx.handleClear
  }, {
    label: _withCtx(({
      value
    }) => [_ctx.getSelectedItemHtmlLabel(value) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      innerHTML: _ctx.getSelectedItemHtmlLabel(value)
    }, null, 8, _hoisted_1)) : _createCommentVNode("", true)]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item[_ctx.valueKey] + 'select',
        label: _ctx.labelToDisplay(item[_ctx.labelKey]),
        value: item[_ctx.valueKey],
        "data-test": _ctx.dataTest + '-' + item[_ctx.valueKey],
        disabled: item.disabled
      }, {
        default: _withCtx(() => [item.htmlContent ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: item.htmlContent
        }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "value", "data-test", "disabled"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "disabled", "size", "loading", "placeholder", "popper-class", "value-on-clear", "clearable", "onBlur", "data-test", "onChange", "onClear"]);
}